import type { DateString, PredefinedFilterDto } from "../api/types";
import type { PeriodId } from "./period";

/**
 * Optional date override applied on top of a predefined filter when building
 * its `/transactions?...` URL. `period` wins over `startDate`/`endDate` if
 * both are passed.
 */
export type DateOverride = {
  period?: PeriodId | null;
  startDate?: DateString | null;
  endDate?: DateString | null;
};

/**
 * Build the `/transactions?...` URL that a predefined filter menu item should
 * navigate to. When `override` is provided, its date fields replace the
 * filter's `startDate`/`endDate` (and a set `period` clears explicit dates).
 */
export const buildPredefinedFilterUrl = (
  filter: PredefinedFilterDto,
  override?: DateOverride,
): string => {
  const params = new URLSearchParams();

  if (override?.period) {
    params.set("period", override.period);
  } else {
    const startDate = override
      ? (override.startDate ?? null)
      : (filter.startDate ?? null);
    const endDate = override
      ? (override.endDate ?? null)
      : (filter.endDate ?? null);
    if (startDate) params.set("startDate", startDate);
    if (endDate) params.set("endDate", endDate);
  }

  filter.source?.forEach((v) => params.append("source", v));
  filter.expenseType?.forEach((v) => params.append("expenseType", v));
  filter.group?.forEach((v) => params.append("group", v));
  filter.category?.forEach((v) => params.append("category", v));
  if (filter.merchant) params.set("merchant", filter.merchant);
  if (filter.description) params.set("description", filter.description);
  if (filter.sort) params.set("sort", filter.sort);
  if (filter.limit) params.set("limit", filter.limit.toString());

  return `/transactions?${params.toString()}`;
};
